type AgentPulseIconProps = {
  className?: string;
  size?: number;
};

export function AgentPulseIcon({ className = "", size = 18 }: AgentPulseIconProps) {
  return (
    <svg
      className={`agent-pulse-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3.75 8.2h5.1l1.85-3.45 2.6 6.7 1.75-3.25h5.2" />
      <path d="M3.75 15.8h4.2l1.55 3.45 2.8-6.65 1.75 3.2h6.2" />
      <circle cx="3.75" cy="8.2" r="1.15" />
      <circle cx="20.25" cy="15.8" r="1.15" />
    </svg>
  );
}
